export * from "./project-added";
export * from "./project-updated";
export * from "./project-not-found";
export * from "./project-already-exists";

import { ProjectAddedMessageTemplateComponent } from "./project-added";
import { ProjectAlreadyExistsMessageTemplateComponent } from "./project-already-exists";
import { ProjectNotFoundMessageTemplateComponent } from "./project-not-found";
import { ProjectUpdatedMessageTemplateComponent } from "./project-updated";

export const ProjectMessageComponents = [
  ProjectAddedMessageTemplateComponent,
  ProjectUpdatedMessageTemplateComponent,
  ProjectNotFoundMessageTemplateComponent,
  ProjectAlreadyExistsMessageTemplateComponent,
];
